const KEY = 'signupPending';
// As long as the backend keeps a signup that is not confirmed.
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

// Both only feed an analytics property, so a browser that blocks storage must not break the
// signup or the sign-in around them.
export const markSignupPending = () => {
  try {
    localStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Nothing to do.
  }
};

export const takeSignupPending = () => {
  try {
    const markedAt = Number(localStorage.getItem(KEY));
    localStorage.removeItem(KEY);

    return markedAt > 0 && Date.now() - markedAt < MAX_AGE_MS;
  } catch {
    return false;
  }
};
